import ReportDom from "../../../../../components/common/ReportDom";
import PurchaseReturnVoucherBody from "./PurchaseReturnVoucherBody";

export default function PurchaseReturnPrint({ id }) {
  return (
    <ReportDom
      renderTable={() => <PurchaseReturnVoucherBody pur_r_id={id} printMode showStamp
            showSignature/>}
    />
  );
}
